module.exports = __webpack_public_path__ + "img/lgOut.f81e3992.svg";